import router from '@/router'
import { SlideService } from '@/services/slider.service'
import { TextPageService } from '@/services/textPage.service'
import { MediaService } from '@/services/media.service'
import { HTTP_STATUS_CODES } from '@/configs/constants.ts'
import { commitPaginationFromMeta, commitPaginationFromLinks, isOk, showErrorToast } from './helpers'

export const mediaActions = {
  async loadSliders({ commit }, page) {
    const response = await SlideService.slides(page)
    commit('SET_SLIDERS', response.data.data)
    commitPaginationFromMeta(commit, response)
  },

  async loadSlideById({ commit }, id) {
    const response = await SlideService.slide(id)
    commit('SET_SLIDE', response.data.data)
  },

  async newSlider({ state }, data) {
    try {
      const response = await SlideService.newSlide({
        ...data
      })

      if (response.status === HTTP_STATUS_CODES.OK) {
        router.push({ name: 'sliders_list' })
        return true
      } else {
        return response
      }
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async updateSlide(_, data) {
    try {
      const response = await SlideService.updateSlide(data, data.id)

      if (response.status === HTTP_STATUS_CODES.OK) {
        return true
      } else {
        return response
      }
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async deleteSlide(_, id) {
    try {
      const response = await SlideService.deleteSlideById(id)

      if (response.status === HTTP_STATUS_CODES.OK) {
        return true
      }
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async orderSlider(_, data) {
    try {
      const response = await SlideService.reorderSlider({
        ...data
      })

      if (response.status === HTTP_STATUS_CODES.OK) {
        return true
      }
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async loadTextPages({ commit }, page) {
    const response = await TextPageService.textPages(page)
    commit('SET_TEXT_PAGES', response.data.data)
    commitPaginationFromMeta(commit, response)
  },

  async loadTextPageById({ commit }, id) {
    const response = await TextPageService.textPage(id)
    commit('SET_TEXT_PAGE', response.data)
  },

  async newTextPage(_, data) {
    try {
      const response = await TextPageService.newTextPage(data)

      if (response.status === HTTP_STATUS_CODES.OK) {
        router.push({ name: 'textpages_list' })
        return true
      } else {
        return response
      }
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async updateTextPage(_, data) {
    try {
      const response = await TextPageService.updateTextPage(data, data.id)

      if (response.status === HTTP_STATUS_CODES.OK) {
        return true
      } else {
        return response
      }
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async deleteTextPage(_, id) {
    try {
      const response = await TextPageService.deleteTextPageById(id)

      if (response.status === HTTP_STATUS_CODES.OK) {
        return true
      }
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async loadMedias({ commit }, page) {
    const response = await MediaService.medias(page)
    commit('SET_MEDIAS', response.data.data)
    commitPaginationFromMeta(commit, response)
  },

  async loadMediaPageById({ commit }, id) {
    const response = await MediaService.mediaPage(id)
    commit('SET_MEDIA_PAGE', response.data.data)
    commit('SET_MEDIA_CATEGORIES', response.data.data.allMediaCategories)
    commit('SET_MEDIA_PAGE_FILES', response.data.data.mediaFiles)
  },

  async loadMediaPageFiles({ commit }, id) {
    const response = await MediaService.mediaPageFiles(id)
    commit('SET_MEDIA_PAGE_FILES', response.data)
  },

  async loadMediaCategory({ commit }) {
    const response = await MediaService.mediaCategories()
    commit('SET_MEDIA_CATEGORIES', response.data.data)
  },

  async filterMediaFiles({ commit }, data) {
    try {
      const response = await MediaService.fetchFilteredMedia(data)

      if (isOk(response)) {
        commit('SET_MEDIA_FILES', response.data.data)
        commitPaginationFromLinks(commit, response)
        commit('SET_TOTAL_MEDIA_FILES', response.data.total)
      }
    } catch (e) {
      showErrorToast(e)
      console.error(e)
    }
  },

  async loadDefaultBanners({ commit }) {
    try {
      const response = await MediaService.defaultBanners()
      if (isOk(response)) {
        commit('SET_DEFAULT_BANNERS', response.data)
      }
    } catch (e) {
      showErrorToast(e)
      console.error(e)
    }
  }
}
